import React from "react";
// import globalHome from "../Assets/gia7.jpg";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Divider,
  IconButton,
  Stack,
} from "@mui/material";
import {
  CheckCircleOutline,
  Language,
  Security,
  Email,
  Public,
  Facebook,
  Twitter,
  LightbulbOutlined,
  FavoriteBorder,
  Diversity3Outlined,
} from "@mui/icons-material";
import Footer from "./footer";
import TopBar from "./topbar";

const AboutUs = () => {
  return (
    <Box sx={{ backgroundColor: "#F6F7F9", minHeight: "100vh" }}>
      <TopBar />

      <Box sx={{ px: 10, py: 6 }}>
        <Typography
          variant="h4"
          fontWeight="bold"
          gutterBottom
          sx={{ color: "#010101" }}
        >
          About Us
        </Typography>

        {/* Introduction */}
        <Paper sx={{ p: 4, borderRadius: 3 }}>
          <Typography
            variant="h6"
            color="text.secondary"
            fontWeight="bold"
            gutterBottom
          >
            Introduction
          </Typography>
          <Divider sx={{ mb: 3 }} />

          <Grid container spacing={4}>
            {/* Left Side Image + Overlay Text */}
            <Grid item xs={12} md={6}>

              <Box
                sx={{
                  position: "relative",
                  borderRadius: 2,
                  overflow: "hidden",
                  // backgroundImage: globalHome,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: 300,
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "center",
                  p: 2,
                  color: "white",
                  textAlign: "center",
                  background:
                    "linear-gradient(180deg, rgba(0,0,0,0.1), rgba(0,0,0,0.8))",
                }}
              >
                <Typography variant="h6" fontWeight="bold">
                  Empowering Connections, Inspiring Growth.
                </Typography>
              </Box>
            </Grid>

            {/* Right Side Features */}
            <Grid item xs={12} md={6}>
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Core Features & Values
              </Typography>

              {[
                {
                  icon: <CheckCircleOutline color="primary" />,
                  title: "Smart Mentor Matching",
                  desc: "AI-powered recommendations",
                },
                {
                  icon: <Diversity3Outlined color="primary" />,
                  title: "Cultural Sensitivity",
                  desc: "Gender preferences, inclusivity",
                },
                {
                  icon: <FavoriteBorder color="primary" />,
                  title: "Flexible Mentorship",
                  desc: "1:1 and group mentoring options",
                },
              ].map((item, index) => (
                <Box key={index} sx={{ mb: 3 }}>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    {item.icon}
                    <Typography fontWeight="bold">{item.title}</Typography>
                  </Stack>
                  <Typography variant="body2" color="text.secondary" sx={{ ml: 4 }}>
                    {item.desc}
                  </Typography>
                </Box>
              ))}
            </Grid>
          </Grid>

          {/* Description */}
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mt: 4, maxWidth: 600 }}
          >
            The Mentorship and Networking Hub connects learners with experienced
            mentors, offering guidance, inspiration, and career growth
            opportunities.
          </Typography>

          <Divider sx={{ my: 4 }} />

          {/* Additional Features */}
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Language color="primary" />
                  <Typography fontWeight="bold">Language Support</Typography>
                </Stack>
                <Typography variant="body2" color="text.secondary" sx={{ ml: 4 }}>
                  Basic translation capabilities
                </Typography>

                <Stack direction="row" alignItems="center" spacing={1}>
                  <Security color="primary" />
                  <Typography fontWeight="bold">Secure & Private</Typography>
                </Stack>
                <Typography variant="body2" color="text.secondary" sx={{ ml: 4 }}>
                  User data protection & control
                </Typography>
              </Stack>
            </Grid>
          </Grid>

          <Divider sx={{ my: 4 }} />

          {/* Mission and Contact */}
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Our Mission & Vision
              </Typography>

              <Stack direction="row" alignItems="center" spacing={1}>
                <LightbulbOutlined color="primary" />
                <Typography fontWeight="bold">Mission</Typography>
              </Stack>
              <Typography variant="body2" color="text.secondary" sx={{ ml: 4 }}>
                To make mentorship accessible to everyone, regardless of
                location, language, or background.
              </Typography>

              <Stack direction="row" alignItems="center" spacing={1} mt={2}>
                <FavoriteBorder color="primary" />
                <Typography fontWeight="bold">Vision</Typography>
              </Stack>
              <Typography variant="body2" color="text.secondary" sx={{ ml: 4 }}>
                A world where mentorship bridges gaps, fosters opportunities, and
                transforms careers.
              </Typography>
            </Grid>

            {/* Contact Section */}
            <Grid item xs={12} md={6}>
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Contact & Social Links
              </Typography>

              <Stack direction="row" alignItems="center" spacing={1}>
                <Email color="primary" />
                <Typography fontWeight="bold">Email</Typography>
              </Stack>
              <Typography variant="body2" color="primary" sx={{ ml: 4 }}>
                support@mentorshiphub.com
              </Typography>

              <Stack direction="row" alignItems="center" spacing={1} mt={2}>
                <Public color="primary" />
                <Typography fontWeight="bold">Website</Typography>
              </Stack>
              <Typography variant="body2" color="primary" sx={{ ml: 4 }}>
                http://www.mentorshiphub.com/
              </Typography>

              <Typography fontWeight="bold" sx={{ mt: 3 }}>
                Social Media Links
              </Typography>
              <Stack direction="row" spacing={2} sx={{ ml: 4, mt: 1 }}>
                <IconButton color="primary">
                  <Facebook />
                </IconButton>
                <IconButton color="primary">
                  <Twitter />
                </IconButton>
              </Stack>
            </Grid>
          </Grid>
        </Paper>
      </Box>

      <Footer />
    </Box>
  );
};

export default AboutUs;
